'use client';

import { LocalNotifications } from '@capacitor/local-notifications';
import moment from 'moment';
import { getHoursFromStartTime, getMinutesFromStartTime } from './dateTime';
import { isDev } from 'app/general'

LocalNotifications.requestPermissions().then(result => {
}).catch(error => {
     isDev && console.log(error)
})

export const newEventNotif = (title: string, startDate: Date, startTime: string) => {
    let d = moment(new Date(startDate))
    d.set("hour", getHoursFromStartTime(startTime))
    d.set("minute", getMinutesFromStartTime(startTime))
    const notifId = d.valueOf()
     isDev && console.log("New Notif", { notifId, title, d })
    d.subtract(2, 'hours');
    if (typeof window !== 'undefined') {
        LocalNotifications.schedule({
            notifications: [
                {
                    title: title,
                    body: "This Event is going to start in 2 hours.",
                    id: notifId,
                    schedule: { at: new Date(d.valueOf()) },
                    // allowWhileIdle: true,
                    // sound: null,
                    // attachments: null,
                    actionTypeId: "",
                    extra: null
                }
            ]
        })
            .then(r =>  isDev && console.log(r))
            .catch(error =>  isDev && console.log(error))
    }

}
export const removeEventNotif = (startDate: Date, startTime: string) => {
    let d = moment(new Date(startDate))
    d.set("hour", getHoursFromStartTime(startTime))
    d.set("minute", getMinutesFromStartTime(startTime))
    const notifId = d.valueOf()
     isDev && console.log("Remove Notif", { notifId })
    if (typeof window !== 'undefined') {
        LocalNotifications.cancel({ notifications: [{ id: notifId }] })
    }
}
